/**
 * gets a string in base 64 that represent a pdf and downloads the file.
 * the name giving for the file will end with current date concatnated.
 * @param {string} pdfBase64
 * @param {string} fileName
 * @returns {boolean} true for success, false otherwise.
 */
export function downloadPdf(pdfBase64: string, fileName: string): boolean {
    if (!((pdfBase64 ?? '') || (fileName ?? ''))) return false;

    try {
        const arrrayBuffer: Uint8Array = base64ToArrayBuffer(pdfBase64);
        const blob: Blob = new Blob([arrrayBuffer], {
            type: 'application/pdf'
        });
        downloadFileHelper(
            blob,
            fileName + '_' + new Date().toLocaleDateString()
        );
        return true;
    } catch (err) {
        return false;
    }
}

/**
 * gets a string in base 64 and using window.atob to create binary string.
 * @param {string} base64
 * @returns {Uint8Array} Uint8 Array that represents the string in binary format.
 */
export function base64ToArrayBuffer(base64: string): Uint8Array {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes: Uint8Array = new Uint8Array(binaryLen);

    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }

    return bytes;
}

function downloadFileHelper(blob: Blob, fileName: string): void {
    const a: HTMLAnchorElement = document.createElement('a');
    document.body.appendChild(a);
    const url: string = window.URL.createObjectURL(blob);
    a.href = url;
    //fix issuse with win 11 heb settings fucking the file if '.' is present.
    a.download = fileName.split(".").join("_");
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}
